module.exports = __webpack_public_path__ + "img/21.ec13c5ff.png";